import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ContactField } from "../components/ContactField";

export const Contact = () => {
  return (
    <>
      <Header />
      <h1>Contact</h1>
      <ContactField />
      <Footer />
    </>
  );
};
